import { useContext } from "react";

import { SearchableSelectControl } from "./SearchableSelectControl";
import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

export function EducationControl(props: CascadiaControlProps) {
  const formContext = useContext(CascadiaJsonFormContext);

  const qualificationTitles = Object.fromEntries(
    (
      formContext as any
    )?.rootSchema?.properties?.education_history?.properties?.educations?.items?.properties?.qualification?.oneOf?.map(
      ({ const: const_, title }: any) => [const_, title]
    ) || []
  ) as { [key: string]: string };

  const items = (
    formContext?.rootValues?.education_history?.educations || []
  ).map(
    (
      { institution: { name: institutionName }, qualification }: any,
      idx: any
    ) => ({
      label: `${institutionName} - ${qualificationTitles[qualification]}`,
      value: idx.toString(),
    })
  ) as { label: string; value: string }[];

  return (
    <SearchableSelectControl
      {...props}
      label={props.uischema.label as string}
      items={items}
      required
      enabled
    />
  );
}

EducationControl.displayName = "EducationControl";

export const EducationRenderer = withCascadiaControlProps(EducationControl);
